This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div class="medalOverlay">
    <div
      v-if="this.success"
      class="overlay"
      :class="medalVisible"
      @click="skip"
    >
      <div class="confetti">
        <div class="dot" v-for="n in 100" :key="n"></div>
      </div>
      <div class="medal">
        <img
          v-if="this.medal == 'super'"
          src="@/assets/images/medals/Platinum.svg"
          alt="Super medal"
        />
        <img
          v-else-if="this.medal == 'gold'"
          src="@/assets/images/medals/Gold.svg"
          alt="Gold medal"
        />
        <img
          v-else-if="this.medal == 'silver'"
          src="@/assets/images/medals/Silver.svg"
          alt="Silver medal"
        />
        <img
          v-else-if="this.medal == 'bronze'"
          src="@/assets/images/medals/Bronze.svg"
          alt="Bronze medal"
        />
        <p v-if="this.achievements.length > 0">
          {{ $t("achievements.new") }}
        </p>
      </div>
    </div>
    <div class="overlay" :class="nextLevelVisible">
      <div class="message">
        <p class="messageHeader neutral">{{ $t(text) }}!</p>
        <div class="buttonsCenter">
          <img
            src="@/assets/images/icons/Back.svg"
            @click="this.$emit('retry')"
            alt="Retry level icon"
          />
          <img
            v-if="allowNextLevel && success"
            src="@/assets/images/icons/Arrow.svg"
            @click="this.$emit('nextLevel')"
            alt="Next level icon"
          />
        </div>
        <div class="buttonsCenter">
          <router-link to="/levels">
            <button class="button success">
              {{ $t("game.levelOverview") }}
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  name: "medal-overlay",
  data() {
    return {
      medalVisible: "overlayVisible",
      nextLevelVisible: "",
      text: "game.achieved",
      miliseconds: 2500,
      overlays: null,
    };
  },
  mounted() {
    this.text = this.success ? "game.achieved" : "game.failed";

    this.displayMedal();
  },
  methods: {
    displayMedal() {
      const next = () => {
        this.medalVisible = "";
        this.nextLevelVisible = "overlayVisible";
      };
      const id = setTimeout(next, this.success ? this.miliseconds : 0);
      this.overlays = [id, next];
    },
    skip() {
      const [id, next] = this.overlays;
      next();
      clearTimeout(id);
    },
  },
  props: {
    medal: String,
    success: Boolean,
    allowNextLevel: Boolean,
    achievements: Array,
  },
})
export default class MedalOverlay extends Vue {}
</script>
